export default __webpack_public_path__ + "static/media/textOnImage.db0c6a1a.svg";